import React, {Component} from "react";
import Cards from './Cards';
import axios from "axios";
import Footer from './Footer';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from 'react-router-dom';
//import store from '../store';
import MessageBox from "./MessageBox";
import { connect } from 'react-redux';
import ItemCard2 from './ItemCard2';
import LeftFadeIn from "../components/animations/LeftFadeIn";


const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },

    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

    const api = axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}/adminuser/categoriesAPI/`
    })
    const GigApi = axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}/seller/`
    })
class Store extends Component {
    constructor(props) {
        super(props);
        this.state = {
            category : [],
            flag:false,
            products:[],
        }
        this.getCategories(); 
        this.getProducts(); 
    }
    componentDidUpdate() {
        if(this.props.auth.user && this.state.flag === false) {
            this.setState({flag:true})
        }
      }
    
    getCategories = async () => {
            let data = await api.get('/').then(({data})=>data);
            this.setState({category:data})
    }
    
    get = async(a,data) => {
        let data1 = await GigApi.get(`Gig/${a.item}/`).then(({data})=>data)
        a.images = data1.images
        a.title = data1.title
        a.price = data1.price
        a.details = data1.details
        a.seller = data1.seller
        a.pid = data1.id
        a.average_rating = data1.average_rating
        this.setState({recommendations :data})
    }
    getProducts = async () => {
        let data = await GigApi.get(`GigsAPI/`).then(({data})=>data);
        this.setState({products:data})
    }

    render() {
        const { auth } = this.props;
    return(
    <div style = {{marginTop: '100px'}}>
       
    {/*All Catagories in Cards*/}

        <div className='mt-5 ms-5'>
            <h1 className='mb-4' style={{fontFamily:'argentecf', color:'black'}}>Products</h1>
            <LeftFadeIn>
                <Carousel responsive={responsive} >
                    {this.state.products.map(a =>  
                        <div className="col mb-4 mt-5" key={a.id}>    
                            <ItemCard2 images={a.images} title={a.title} price ={a.price} details={a.details} seller={a.seller} itemID={a.id} rating={a.average_rating} />
                        </div>
                    )}
                </Carousel>
            </LeftFadeIn>
            </div><br/>
        <hr />
        
        <Footer />
        
    </div>
    )}
    }

const mapStateToProps = state => ({
    auth: state.auth
});
    
export default connect(mapStateToProps, { })(Store);
